export default {
  fulfilled: 'Fulfilled',
  unfulfilled: 'Unfulfilled',
  partially_fulfilled: 'Partially Fulfilled',
  partially_restocked: 'Partially Restocked',
  restocked: 'Restocked'
}
